import { render, staticRenderFns } from "./type.vue?vue&type=template&id=27159cce&scoped=true&"
var script = {}
import style0 from "./type.vue?vue&type=style&index=0&id=27159cce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27159cce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27159cce')) {
      api.createRecord('27159cce', component.options)
    } else {
      api.reload('27159cce', component.options)
    }
    module.hot.accept("./type.vue?vue&type=template&id=27159cce&scoped=true&", function () {
      api.rerender('27159cce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/error-page/recentlyLaunched/type.vue"
export default component.exports